import { recordTrack } from '@saucelabs/sl-util-segmentio';
import isEqual from 'lodash.isequal';

import * as actions from './actions';
import * as functions from './functions';
import * as selectors from './selectors';
import { LS_DASHBOARD_FILTERS } from './constants';

import { operations } from './index';

export const clearFilters = (payload) => (dispatch, getState) => {
  dispatch(actions.resetFilters(payload));
  return Promise.resolve(
    functions.setLocalStorageFilters(selectors.filtersSelector(getState())),
  );
};

export const toggleStatus = (payload) => (dispatch, getState) => {
  dispatch(actions.toggleStatus(payload));
  return Promise.resolve(
    functions.setLocalStorageFilters(selectors.filtersSelector(getState())),
  );
};

export const trackedToggleJobFilter = (status, metadata = {}) => (dispatch) => (
  Promise.all([
    dispatch(toggleStatus(status)),
    dispatch(recordTrack('Toggled job filter', { ...metadata, status })),
  ])
);

export const setPerformanceFilter = (payload) => (dispatch, getState) => {
  dispatch(actions.togglePerformance(payload));
  return Promise.resolve(
    functions.setLocalStorageFilters(selectors.filtersSelector(getState())),
  );
};

export const selectOwner = (payload) => (dispatch, getState) => {
  const currentOwner = selectors.selectOwnerByType(getState(), payload.type);
  if (isEqual(currentOwner?.toJS?.(), payload.data)) {
    return;
  }

  dispatch(actions.selectOwner(payload));
  functions.setLocalStorageFilters(selectors.filtersSelector(getState()));
};

export const clearOwner = (payload) => (dispatch, getState) => {
  dispatch(actions.clearOwner(payload));
  return Promise.resolve(
    functions.setLocalStorageFilters(selectors.filtersSelector(getState())),
  );
};

export const setSearch = (payload) => (dispatch, getState) => {
  dispatch(actions.setSearch(payload));
  functions.setLocalStorageFilters(selectors.filtersSelector(getState()));
};

export const selectStatuses = (payload) => (dispatch, getState) => {
  dispatch(actions.selectStatuses(payload));
  functions.setLocalStorageFilters(selectors.filtersSelector(getState()));
};

export const clearStatuses = (payload) => (dispatch, getState) => {
  dispatch(actions.clearStatuses(payload));
  return Promise.resolve(
    functions.setLocalStorageFilters(selectors.filtersSelector(getState())),
  );
};

export const setInitialOwner = (owner) => (dispatch, getState) => {
  if (!owner) {
    return;
  }

  const currentOwner = selectors.selectOwnerByType(getState(), owner.type);
  // If there's already a currently selected owner, that means we init'd from
  // localStorage and there's no need to select the default owner now.
  const isOwnerSet = currentOwner && !currentOwner.isEmpty();
  // Check for userId as well in case the filters were loaded from localStorage, but
  // in the old format where an id was not required. This is only applicable to the
  // "My tests" filter since it previously did not include the user id, hence the check on
  // the currentOwner type.
  const isUserIdSet = currentOwner?.get('type') === 'user' && currentOwner?.get('id');
  if ((isOwnerSet && currentOwner.get('type') !== 'user') || isUserIdSet) {
    return;
  }

  dispatch(operations.selectOwner(owner));
};

export const initializeFilters = ({
  fetchUsers,
  fetchUserIds,
  fetchTeams,
  isOpenSauceUser,
  ownerFilter,
  username,
}) => async (dispatch, getState) => {
  const lsFilters = window.localStorage.getItem(
    LS_DASHBOARD_FILTERS,
  );

  if (lsFilters) {
    dispatch(actions.updateFiltersFromLS({ filters: lsFilters }));
  }

  const state = getState();
  const filtersUser = state.apps.jobs.filters.get('username');

  // if different user is logged in, we want to reset filters in localStorage to default state
  if (filtersUser !== username) {
    dispatch(clearFilters({ username }));
  }

  if (isOpenSauceUser) {
    dispatch(actions.filtersInitialized());
    dispatch(actions.selectOwner(ownerFilter));
    functions.setLocalStorageFilters(selectors.filtersSelector(getState()));

    return Promise.resolve();
  }

  return Promise.all([
    fetchUserIds ? dispatch(actions.getUsers()) : Promise.resolve(),
    fetchUsers ? dispatch(actions.getOrgUsers(username)) : Promise.resolve(),
    fetchTeams ? dispatch(actions.getTeamList()) : Promise.resolve(),
  ]).then(() => {
    dispatch(actions.filtersInitialized());
    dispatch(setInitialOwner(ownerFilter));
  });
};
